"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateVats = void 0;
/**
 * Aggregates tasks by vat percentage
 */
const aggregateVats = (tasks) => {
    const vatMap = new Map();
    tasks.forEach((task) => {
        const { totalAmountBeforeTaxes, totalVatAmount, vatPercentage } = task;
        if (vatMap.has(vatPercentage)) {
            const vat = vatMap.get(vatPercentage);
            vatMap.set(vatPercentage, {
                totalAmountBeforeTaxes: vat.totalAmountBeforeTaxes + totalAmountBeforeTaxes,
                totalVatAmount: vat.totalVatAmount + totalVatAmount,
                vatPercentage,
            });
        }
        else {
            vatMap.set(vatPercentage, {
                totalAmountBeforeTaxes,
                totalVatAmount,
                vatPercentage,
            });
        }
    });
    const entries = [...vatMap.values()];
    const sorted = entries.sort((a, b) => b.vatPercentage - a.vatPercentage);
    return sorted;
};
exports.aggregateVats = aggregateVats;
